import { useEffect } from "react";
import { useSelector } from "react-redux";
import { setMinorModeActive } from "../../utils/analytics";
import { isMinorAgeBand } from "../../constants/ageBands";

/**
 * minors-w2-fe-settings-age-dob-and-referral-gate (mission minors-13plus,
 * B.17 "minor mode"). Mounted once in App.js, gated on MINORS_POLICY_ENABLED
 * so it renders nothing (and touches nothing) while the flag is off. Syncs
 * the current user's age_band into utils/analytics.js's minor-mode gate —
 * kept as a side-effect component (not a redux-coupled read inside
 * analytics.js itself) so that module stays dependency-free and
 * independently testable.
 */
const MinorModeSync = () => {
  const ageBand = useSelector(
    (state) => state.userProfile?.userProfile?.age_band
  );

  useEffect(() => {
    setMinorModeActive(isMinorAgeBand({ age_band: ageBand }));
  }, [ageBand]);

  return null;
};

export default MinorModeSync;
